import { IPopupHelperProps, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import { DownloadAppModalData } from './DownloadAppModal.types';

export const renderDownloadAppModal = (params: Omit<IPopupHelperProps<DownloadAppModalData>, 'popupName'>) =>
    openPopupHelper({ popupName: popupNames.MOBILE_DOWNLOAD_APP, ...params });
